import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function minArrayLengthValidator(min: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        if (!Array.isArray(control.value) || control.value.length < min) {
            return { minArrayLength: { requiredLength: min, actualLength: Array.isArray(control.value) ? control.value.length : 0 } };
        }
        return null;
    };
}
